import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import { report1, report2 } from "../../assets";
import { Link } from "react-router-dom";


function Report() {

  return (
    <>
      <AppWrapper
        pagename={"reports"}
      >
        <StyledReport>
          <Title title={"Report"} btnName={""} />

          <div className="row justify-content-between">
            <div className="col-md-6 mb-4">
              <Link to='business'>
                <img src={report1} alt="Overall Business" width="100%" />
              </Link>
            </div>
            <div className="col-md-6 mb-4">
              <Link to='store'>
                <img src={report2} alt="Store Business" width="100%" />
              </Link>
            </div>
          </div>

        </StyledReport>



      </AppWrapper>

    </>
  );
}

export default Report;

const StyledReport = styled.div`

`;